export default state => state.features.dashboard.pages.list;



// WEBPACK FOOTER //
// ./app/features/dashboard/selectors/pages/list/pageSelector.js